const navLinkStyledLogin = {
  text: 'Olvidó su contraseña?',
  qrcode: 'Leer datos públicos'
};

export default navLinkStyledLogin;
